<template>
  <div>
    <van-nav-bar
      title="修改课程"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />

    <van-form @submit="onSubmit">
      <van-field
        disabled
        clearable
        v-model="cname"
        name="cname"
        label="课程名"
        placeholder="课程名"
        :rules="[{ required: true, message: '请填写课程名' }]"
      />

      <van-field
        disabled
        readonly
        clickable
        name="weekandtimes"
        :value="weekvalue+':'+timesvalue"
        label="上课时间"
        placeholder="点击选择周几"
      />


      <van-field
        readonly
        clickable
        :value="startTime"
        name="startUnixTime"
        label="抢课时间"
        placeholder="点击选择抢课开始时间"
        @click="startTimeShowPicker = true"
      />

      <van-popup v-model="startTimeShowPicker" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="datetime"
          title="选择抢课开始时间"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="startOnConfirm"
          @cancel="startTimeShowPicker = false"
        />
      </van-popup>

      <van-field
        disabled
        readonly
        clickable
        name="tecnameandnum"
        :value="tecnameAndNumValue"
        label="教师"
        placeholder="点击选择教师"
      />

      <van-field
        readonly
        clickable
        name="campusArea"
        :value="campusAreaValue"
        label="校区"
        placeholder="点击选择校区"
        @click="showCampusAreaPicker = true"
      />
      <van-popup v-model="showCampusAreaPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="campusAreaColumns"
          @confirm="campusAreaOnConfirm"
          @cancel="showCampusAreaPicker = false"
          :default-index="0"
        />
      </van-popup>
      <van-cell title="最大人数">
        <van-stepper theme="round" v-model="maxp" integer/>
      </van-cell>


      <van-field
        v-model="introduction"
        rows="2"
        autosize
        name="introduction"
        clearable
        label="简介"
        type="textarea"
        maxlength="500"
        placeholder="课程简介"
        show-word-limit
        :rules="[{ required: true, message: '请填写课程简介' }]"
      />

      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">
          修改课程
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import {GetCourseInfoById, ModifyCourse} from "@/network/course";
import Vue from 'vue';
import {
  NavBar,
  Form,
  Field,
  Button,
  Picker,
  Popup,
  Dialog,
  Col,
  Row,
  DatetimePicker,
  Uploader,
  Stepper,
  Cell,
} from 'vant';

Vue.use(Form);
Vue.use(NavBar);
Vue.use(Field);
Vue.use(Button);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Dialog);
Vue.use(Col);
Vue.use(Row);
Vue.use(DatetimePicker);
Vue.use(Uploader);
Vue.use(Stepper);
Vue.use(Cell);
export default {
  name: "ModifyCourse",
  data() {
    return {
      //Course Name
      cname: '',

      //Maximum number of people
      maxp: 1,

      //Class Time
      weekvalue: '',
      timesvalue: '',

      //Rush Course time
      startTime: '',
      startTimeShowPicker: false,
      currentDate: new Date(),
      minDate: new Date(),
      maxDate: this.GLOBAL.end_select_time,
      startUnixTime: '',

      //Teacher and Teacher`s number
      tecnameAndNumValue: '',

      campusAreaValue:'南校区',
      campusAreaColumns: ['南校区','济源校区'],
      showCampusAreaPicker: false,

      //Course introduction
      introduction: "",

      course_id: 0,
    }
  },
  activated() {
    GetCourseInfoById(this.$route.query.id).then(res => {
      this.course_id = res.id;
      this.cname = res.cname;
      this.weekvalue = res.week;
      this.timesvalue = res.times;
      this.startTime = new Date(parseInt(res.starttime)).toLocaleString();
      this.currentDate = new Date(parseInt(res.starttime));
      this.startUnixTime = res.starttime;
      this.maxp = res.maxp;
      this.tecnameAndNumValue = res.tId + ':' + res.tName + ':' + res.tNum + ':' + res.tGender;
      this.campusAreaValue = res.campusArea;
      this.introduction = res.des;
    })
  },
  methods: {
    Dialoginfo(title, message) {
      Dialog.alert({
        title,
        message
      }).then(() => {
        // on close
      });
    }
    ,
    onClickLeft() {
      this.$router.replace("/course");
    },
    onSubmit(values) {
      if (values.introduction === "") {
        this.Dialoginfo('提示', '俱乐部简介不能为空');
      } else {
        Dialog.confirm({
          title: '警告',
          message: '确定要修改课程吗'
        }).then(() => {
          ModifyCourse(this.course_id, values.introduction, this.maxp, this.startUnixTime,this.campusAreaValue).then(res => {
            if (res) {
              this.Dialoginfo('提示', '修改成功');
            } else {
              this.Dialoginfo('提示', '修改失败,课程名称可能重复。');
            }
          });
          // on confirm
        }).catch(() => {
          // on cancel
        });

      }
    }
    ,
    startOnConfirm(value) {
      this.startUnixTime = value.getTime().toString();
      this.startTime = value.toLocaleString();
      this.startTimeShowPicker = false;
    },
    campusAreaOnConfirm(value) {
      this.campusAreaValue = value;
      this.showCampusAreaPicker = false;
    },
  }
}
</script>

<style scoped>

</style>
